import { OrderStatus } from "@ancon/wildcat-types";
import BodyText from "@ancon/wildcat-ui/web/orderweb/BodyText";
import clsx from "clsx";

import styles from "./OrderStatusLabel.module.scss";

export default function OrderStatusLabel({ status }: { status: OrderStatus }) {
  function getStatusText() {
    switch (status) {
      case OrderStatus.NotRefunded:
        return "Completed";

      case OrderStatus.PartlyRefunded:
        return "Partly refunded";

      case OrderStatus.Refunded:
        return "Refunded";

      default:
        return "";
    }
  }

  return (
    <div
      className={clsx(styles.labelWrapper, {
        [styles.notRefunded]: status === OrderStatus.NotRefunded,
        [styles.partlyRefunded]: status === OrderStatus.PartlyRefunded,
        [styles.refunded]: status === OrderStatus.Refunded,
      })}
    >
      <BodyText
        className={clsx(styles.labelText, {
          [styles.notRefunded]: status === OrderStatus.NotRefunded,
          [styles.partlyRefunded]: status === OrderStatus.PartlyRefunded,
          [styles.refunded]: status === OrderStatus.Refunded,
        })}
      >
        {getStatusText()}
      </BodyText>
    </div>
  );
}
